export type ReasoningEffort = "none" | "low" | "high" | "max";

// Only expose levels explicitly documented by the Cloudflare model endpoints.
// https://developers.cloudflare.com/workers-ai/models/glm-5.3{,-flash}/
// https://developers.cloudflare.com/workers-ai/models/deepseek-v4-{pro-0813,flash-0731}/
const levels: Record<string, readonly ReasoningEffort[]> = {
  "@cf/zai-org/glm-5.3": ["low", "high", "max"],
  "@cf/zai-org/glm-5.3-flash": ["low", "high", "max"],
  "@cf/deepseek-ai/deepseek-v4-pro-0813": ["none", "low", "high", "max"],
  "@cf/deepseek-ai/deepseek-v4-flash-0731": ["none", "low", "high", "max"],
};
export const reasoningLevels = (model: string): readonly ReasoningEffort[] => Object.hasOwn(levels, model) ? levels[model] : [];
export const supportedReasoningEffort = (model: string, value: unknown): ReasoningEffort | undefined =>
  typeof value === "string" && reasoningLevels(model).includes(value as ReasoningEffort) ? value as ReasoningEffort : undefined;
